import { render, staticRenderFns } from "./CalabozoDetenidoModal.vue?vue&type=template&id=5f41e7aa&scoped=true"
import script from "./CalabozoDetenidoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CalabozoDetenidoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalabozoDetenidoModal.vue?vue&type=style&index=0&id=5f41e7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41e7aa",
  null
  
)

export default component.exports